import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  createdPosts: [],
  socialPages: [],
  requesting: false,
  error: null,
  uploading: false,
  uploadError: null,
};

const post = createReducer(initialState, {
  [actionTypes.POST_CREATE_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.POST_CREATE_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false, status: 0 };
  },
  [actionTypes.POST_CREATE_SUCCESS](state, { payload }) {
    return {
      ...state,
      createdPosts: payload,
      requesting: false,
      error: null,
    };
  },
  // upload
  [actionTypes.UPLOAD_REQUEST](state) {
    return { ...state, uploading: true, uploadError: null };
  },
  [actionTypes.UPLOAD_ERROR](state, { payload }) {
    return { ...state, uploadError: payload, uploading: false };
  },
  [actionTypes.UPLOAD_SUCCESS](state) {
    return {
      ...state,
      uploading: false,
      uploadError: null,
    };
  },
  // social pages
  // [actionTypes.SOCIAL_PAGES_GET_LIST_REQUEST](state, payload) {
  //   return { ...state, requesting: true, uploadError: null }
  // },
  // [actionTypes.SOCIAL_PAGES_GET_LIST_ERROR](state, { payload }) {
  //   return { ...state, uploadError: payload, requesting: false };
  // },
  [actionTypes.SOCIAL_PAGES_GET_LIST_STORE](state, { payload }) {
    return { ...state, socialPages: payload };
  },
  // reset state
  [actionTypes.POST_RESET_STATE]() {
    return initialState;
  },
});

export default post;

export const getIsRequesting = (state) => state.post.requesting;
export const getIsRequestingPost = (state) => state.post.requesting;
export const getError = (state) => state.post.error;
export const getSocialPages = (state) => state.post.socialPages;
export const getCreatedPosts = (state) => state.post.createdPosts;

export const getIsUploading = (state) => state.post.uploading;
export const getUploadError = (state) => state.post.uploadError;
